import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ion-modal-footer',
  standalone: true,
  templateUrl: './modal-footer.component.html',
  styleUrls: ['./modal-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalFooterComponent {}
